import React, { useState, useEffect } from 'react';
import { Edit, Trash2, Save } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import ImageUploader from '../../components/admin/ImageUploader';
import axios from 'axios';

const TestimonialsManager = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/testimonials`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTestimonials(response.data.testimonials);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/testimonials/${editing}`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setEditing(null);
      fetchTestimonials();
    } catch (error) {
      alert('Erreur');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer ?')) return;
    try {
      const token = localStorage.getItem('admin_token');
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/admin/testimonials/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchTestimonials();
    } catch (error) {
      console.error('Error:', error);
    }
  };

  if (loading) return <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div></div>;

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">Témoignages</h1>
      <div className="grid gap-4">
        {testimonials.map((testimonial) => (
          <Card key={testimonial.id}>
            {editing === testimonial.id ? (
              <CardContent className="pt-6 space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <div><Label>Nom</Label><Input value={formData.name || ''} onChange={(e) => setFormData({ ...formData, name: e.target.value })} /></div>
                  <div><Label>Rôle (FR)</Label><Input value={formData.role || ''} onChange={(e) => setFormData({ ...formData, role: e.target.value })} /></div>
                  <div><Label>Role (EN)</Label><Input value={formData.role_en || ''} onChange={(e) => setFormData({ ...formData, role_en: e.target.value })} /></div>
                  <div><Label>Note (1-5)</Label><Input type="number" min="1" max="5" value={formData.rating || 5} onChange={(e) => setFormData({ ...formData, rating: parseInt(e.target.value) })} /></div>
                </div>
                <div><Label>Témoignage (FR)</Label><textarea className="w-full border rounded-md p-2 min-h-[100px]" value={formData.content || ''} onChange={(e) => setFormData({ ...formData, content: e.target.value })} /></div>
                <div><Label>Testimonial (EN)</Label><textarea className="w-full border rounded-md p-2 min-h-[100px]" value={formData.content_en || ''} onChange={(e) => setFormData({ ...formData, content_en: e.target.value })} /></div>
                <div>
                  <ImageUploader
                    value={formData.image || ''}
                    onChange={(url) => setFormData({ ...formData, image: url })}
                    label="Photo du Client"
                  />
                </div>
                <div className="flex gap-2">
                  <Button onClick={handleSave} className="bg-green-600"><Save className="w-4 h-4 mr-2" />Sauvegarder</Button>
                  <Button onClick={() => setEditing(null)} variant="outline">Annuler</Button>
                </div>
              </CardContent>
            ) : (
              <div className="flex items-start gap-4 p-6">
                <img src={testimonial.image} alt={testimonial.name} className="w-16 h-16 rounded-full object-cover" />
                <div className="flex-1">
                  <h3 className="font-bold">{testimonial.name}</h3>
                  <p className="text-sm text-gray-500">{testimonial.role}</p>
                  <p className="text-sm text-gray-700 mt-2 italic">"{testimonial.content}"</p>
                  <p className="text-yellow-500 mt-1">{'⭐'.repeat(testimonial.rating)}</p>
                </div>
                <div className="flex gap-2">
                  <Button size="sm" onClick={() => { setEditing(testimonial.id); setFormData(testimonial); }}><Edit className="w-4 h-4" /></Button>
                  <Button size="sm" variant="destructive" onClick={() => handleDelete(testimonial.id)}><Trash2 className="w-4 h-4" /></Button>
                </div>
              </div>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
};

export default TestimonialsManager;
